import {
  createPlugin,
  createRouteRef,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'core-dumps',
});

export const coreDumpsPlugin = createPlugin({
  id: 'core-dumps',
  routes: {
    root: rootRouteRef,
  },
});

export const CoreDumpsPage = coreDumpsPlugin.provide(
  createRoutableExtension({
    name: 'CoreDumpsListPage',
    component: () => import('./components/S3ListPage').then(m => m.S3ListPage),
    mountPoint: rootRouteRef,
  }),
);
